module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_wrap",
    attrs: {
      "id": "login"
    }
  }, [_c('router-view'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "copy_right"
  }, [_c('div', {
    staticClass: "text-center copy_right_info"
  }, [_c('span', {}, [_vm._v("Copyright ©2017 北京中科联诚软件股份有限公司 版权所有")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-183bab0e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/loginGroup/login.vue
// module id = 1240
// module chunks = 1